import { j as f } from "../../../node_modules/react/jsx-runtime.js";
import x from "../../../utils/extractTokenValue.js";
import { getHeadingLevel as T } from "../../../utils/getHeading.js";
function L(t) {
  if (!t)
    return "";
  const i = t.replace(/<\/?[a-zA-Z][a-zA-Z0-9]*\/?>/g, "");
  return H(i).trim();
}
function H(t) {
  return t.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}
const b = ({
  type: t,
  startHeading: i,
  content: r,
  parent: u,
  extraClasses: o,
  titleLevelClass: m
}) => {
  const g = {
    title: "title-level-title",
    subTitle: "title-level-sub-title",
    additionalText: "title-level-additional-text",
    description: "title-level-description",
    titulo: "title-level-title",
    subtitulo: "title-level-sub-title",
    textoadicional: "title-level-additional-text",
    descricao: "title-level-description",
    none: ""
  }, l = r[t];
  if (!l)
    return null;
  let e = "";
  if (typeof document < "u") {
    const d = document.createElement("div");
    d.innerHTML = l, e = (d.textContent || "").trim();
  } else
    e = L(l);
  const n = ">tl-", s = e == null ? void 0 : e.toLowerCase().startsWith(n), a = s ? x(e == null ? void 0 : e.toLowerCase(), n) : t;
  let p = s ? e.slice(n.length + a.length) : l, c = m || g[a];
  o && o[t] && (c += " " + o[t]);
  const v = T(
    i,
    t,
    r,
    u
  );
  return /* @__PURE__ */ f.jsx(v, { className: c, dangerouslySetInnerHTML: { __html: p } });
}, M = b;
export {
  M as default
};
